

export enum EnumIndEscala {
    N=78, S=83
}